export default __webpack_public_path__ + "media/images/logo/media/japan_agri_news-25ba96029d98d93d25378dc97ac7bdcb.jpg";